import { api } from "../../utils/api";

export async function sendLeadMessage(leadId, messageData) {
  try {
    const response = await api.post(`/lead/message/${leadId}`, messageData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    
    if (response.data && response.data.statusCode === 200) {
      return response.data;
    }
    
    throw new Error("Erro ao enviar mensagem para o lead");
  } catch (error) {
    console.error("Erro ao enviar mensagem do WhatsApp:", error);
    
    // Verificar se é um erro de resposta da API com status específico
    if (error.response && error.response.data) {
      const apiError = error.response.data;
      // Propagar o erro da API com mais detalhes
      const customError = new Error(apiError.message || "Erro ao enviar mensagem para o lead");
      customError.statusCode = apiError.statusCode || error.response.status;
      customError.apiMessage = apiError.message;
      throw customError;
    }
    
    throw error;
  }
}
